import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Procrastination",
  "description": "",
  "published": "2008-05-24T00:00:00.000Z",
  "redirect_from": ["/blog/procrastination/swizec/109"],
  "categories": "funny",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><a parentName="p" {...{
        "href": "http://shrani.si/?17/Ez/1qeJiqk3/handler.jpg"
      }}><img parentName="a" {...{
          "src": "https://shrani.si/t/17/Ez/1qeJiqk3/handler.jpg",
          "alt": "Shrani.si"
        }}></img></a></p>
    <p>{`I'll find a blog for it later`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      